import { render, staticRenderFns } from "./SeasonalitiesList.vue?vue&type=template&id=678fcb4e"
import script from "./SeasonalitiesList.vue?vue&type=script&lang=js"
export * from "./SeasonalitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports